function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import PropTypes from 'prop-types';
import { getLensModeEnlargedImageCoordinates, getInPlaceEnlargedImageCoordinates } from './lib/imageCoordinates';
import { LargeImageShape } from './prop-types/Image';
import { ContainerDimensions } from './prop-types/EnlargedImage';
import { noop } from './utils';
import Point from './prop-types/Point';
import { getEnlargedImageContainerStyle, getEnlargedImageStyle } from './lib/styles';
var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);
  var _super = _createSuper(_default);
  function _default(props) {
    var _this;
    _classCallCheck(this, _default);
    _this = _super.call(this, props);
    _this.state = {
      isTransitionEntering: false,
      isTransitionActive: false,
      isTransitionLeaving: false,
      isTransitionDone: false
    };
    _this.timers = [];
    return _this;
  }
  _createClass(_default, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.scheduleCssTransition(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.timers.forEach(function (timerId) {
        clearTimeout(timerId);
      });
    }
  }, {
    key: "scheduleCssTransition",
    value: function scheduleCssTransition(nextProps) {
      var _this2 = this;
      var _this$props = this.props,
        fadeDurationInMs = _this$props.fadeDurationInMs,
        isActive = _this$props.isActive,
        isPositionOutside = _this$props.isPositionOutside;
      var willIsActiveChange = isActive !== nextProps.isActive;
      var willIsPositionOutsideChange = isPositionOutside !== nextProps.isPositionOutside;
      if (!willIsActiveChange && !willIsPositionOutsideChange) {
        return;
      }
      if (nextProps.isActive && !nextProps.isPositionOutside) {
        this.setState({
          isTrainsitionDone: false,
          isTransitionEntering: true
        });
        this.timers.push(setTimeout(function () {
          _this2.setState({
            isTransitionEntering: false,
            isTransitionActive: true
          });
        }, 0));
      } else {
        this.setState({
          isTransitionLeaving: true,
          isTransitionActive: false
        });
        this.timers.push(setTimeout(function () {
          _this2.setState({
            isTransitionDone: true,
            isTransitionLeaving: false
          });
        }, fadeDurationInMs));
      }
    }
  }, {
    key: "getImageCoordinates",
    value: function getImageCoordinates() {
      var _this$props2 = this.props,
        cursorOffset = _this$props2.cursorOffset,
        largeImage = _this$props2.largeImage,
        containerDimensions = _this$props2.containerDimensions,
        position = _this$props2.position,
        smallImage = _this$props2.smallImage,
        isInPlaceMode = _this$props2.isInPlaceMode;
      if (isInPlaceMode) {
        return getInPlaceEnlargedImageCoordinates({
          containerDimensions: containerDimensions,
          largeImage: largeImage,
          position: position
        });
      }
      return getLensModeEnlargedImageCoordinates({
        containerDimensions: containerDimensions,
        cursorOffset: cursorOffset,
        largeImage: largeImage,
        position: position,
        smallImage: smallImage
      });
    }
  }, {
    key: "isVisible",
    get: function get() {
      var _this$state = this.state,
        isTransitionEntering = _this$state.isTransitionEntering,
        isTransitionActive = _this$state.isTransitionActive,
        isTransitionLeaving = _this$state.isTransitionLeaving;
      return isTransitionEntering || isTransitionActive || isTransitionLeaving;
    }
  }, {
    key: "containerStyle",
    get: function get() {
      var _this$props3 = this.props,
        containerStyle = _this$props3.containerStyle,
        containerDimensions = _this$props3.containerDimensions,
        fadeDurationInMs = _this$props3.fadeDurationInMs,
        isPortalRendered = _this$props3.isPortalRendered,
        isInPlaceMode = _this$props3.isInPlaceMode;
      var isTransitionActive = this.state.isTransitionActive;
      return getEnlargedImageContainerStyle({
        containerDimensions: containerDimensions,
        containerStyle: containerStyle,
        fadeDurationInMs: fadeDurationInMs,
        isTransitionActive: isTransitionActive,
        isInPlaceMode: isInPlaceMode,
        isPortalRendered: isPortalRendered
      });
    }
  }, {
    key: "imageStyle",
    get: function get() {
      var _this$props4 = this.props,
        imageStyle = _this$props4.imageStyle,
        largeImage = _this$props4.largeImage;
      return getEnlargedImageStyle({
        imageCoordinates: this.getImageCoordinates(),
        imageStyle: imageStyle,
        largeImage: largeImage
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        containerClassName = _this$props5.containerClassName,
        imageClassName = _this$props5.imageClassName,
        isLazyLoaded = _this$props5.isLazyLoaded,
        largeImage = _this$props5.largeImage,
        _this$props5$largeIma = _this$props5.largeImage,
        _this$props5$largeIma2 = _this$props5$largeIma.alt,
        alt = _this$props5$largeIma2 === void 0 ? '' : _this$props5$largeIma2,
        _this$props5$largeIma3 = _this$props5$largeIma.onLoad,
        onLoad = _this$props5$largeIma3 === void 0 ? noop : _this$props5$largeIma3,
        _this$props5$largeIma4 = _this$props5$largeIma.onError,
        onError = _this$props5$largeIma4 === void 0 ? noop : _this$props5$largeIma4;
      var component = /*#__PURE__*/React.createElement("div", {
        className: containerClassName,
        style: this.containerStyle
      }, /*#__PURE__*/React.createElement("img", {
        alt: alt,
        className: imageClassName,
        src: largeImage.src,
        srcSet: largeImage.srcSet,
        sizes: largeImage.sizes,
        style: this.imageStyle,
        onLoad: onLoad,
        onError: onError
      }));
      if (isLazyLoaded) {
        return this.isVisible ? component : null;
      }
      return component;
    }
  }]);
  return _default;
}(React.Component);
_default.displayName = 'EnlargedImage';
_default.defaultProps = {
  fadeDurationInMs: 0,
  isLazyLoaded: true
};
_default.propTypes = {
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.object,
  cursorOffset: Point,
  position: Point,
  fadeDurationInMs: PropTypes.number,
  imageClassName: PropTypes.string,
  imageStyle: PropTypes.object,
  isActive: PropTypes.bool,
  isLazyLoaded: PropTypes.bool,
  largeImage: LargeImageShape,
  containerDimensions: ContainerDimensions,
  isPortalRendered: PropTypes.bool,
  isInPlaceMode: PropTypes.bool
};
export { _default as default };